import { isFeatureEnabled } from 'owa-feature-flags';

export default function isSonoraPluginEnabled(): boolean {
    if (
        isFeatureEnabled('honeybee-sonora') &&
        (isFeatureEnabled('honeybee-sonora-clipboard') || isFeatureEnabled('honeybee-sonora-file'))
    ) {
        return true;
    }
    return false;
}
